import axios from 'axios'

export default {
    getStatus(token) {
        return axios.get(`/unauthenticated/document-shares/${token}/status`)
    },

    get(token) {
        return axios.get(`/document-shares/${token}`)
    },

    verifyCode(token, accessCode) {
        return axios.post(`/unauthenticated/document-shares/${token}/verify-code`, { accessCode })
    },

    getAsGuest(token, guestToken) {
        return axios.get(`/unauthenticated/document-shares/${token}`, {
            headers: { Authorization: `Bearer ${guestToken}` },
        })
    },

    getDocumentFileUrl(token, documentId) {
        return `${env('VUE_APP_API_URL')}/document-shares/${token}/documents/${documentId}/file`
    },

    getGuestDocumentFileUrl(token, documentId) {
        return `${env('VUE_APP_API_URL')}/unauthenticated/document-shares/${token}/documents/${documentId}/file`
    },
}
